import { Component, Input, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { ProgramEditorService } from "../program-editor.service";
import { TypesService } from "../../types.service";

import { Program, ProgramDetails, ProgramFunding } from "@models/program";
import { ActNowDictionaryItem } from "@models/common";

import { Subscription } from "rxjs/Subscription";

declare var jQuery: any;

@Component({
    templateUrl: "./program-details-editor.component.html",
    selector: "app-program-details-editor"
})

export class ProgramDetailsEditorComponent implements OnInit, AfterViewInit {
    @Input() reviewing = false;
    public baseColumns: number = 6;
    public dataReadySub: Subscription;
    public model: ProgramDetails;

    constructor(private editorService: ProgramEditorService, private typeService: TypesService) { }

    ngOnInit(): void {
        this.editorService.updateCurrentTab(2);
        this.getData();
        if (this.reviewing) {
            this.baseColumns = 12;
        }
    }

    ngAfterViewInit(): void {
        if (this.editorService.physicalSettings == undefined) {
            this.typeService.getPhysicalSettings().subscribe(
                response => {
                    this.editorService.physicalSettings = response;
                    this.editorService.completePhysicalSettingsFetch();
                });
        }
        if (this.editorService.licensingOpts == undefined) {
            this.typeService.getLicensingOptions().subscribe(
                response => {
                    this.editorService.licensingOpts = response;
                    this.editorService.completeLicensingOptsFetch();
                });
        }
    }


    getData(): void {
        let ready = this.editorService.dataReady;
        if (ready) {
            let program = this.editorService.getProgram();
            if (program.details == undefined) {
                this.model = new ProgramDetails();
                this.model.funding = new ProgramFunding();
                program.details = this.model;
                this.updateModel();
            } else {
                this.model = program.details;
                if (this.model.funding == undefined) {
                    this.model.funding = new ProgramFunding();
                    this.updateModel();
                }
            }
            if (this.dataReadySub != undefined) {
                this.dataReadySub.unsubscribe();
            }
        } else {
            this.dataReadySub = this.editorService.dataReady$.subscribe(x => this.getData());
        }
    }


    updateModel(): void {
        let program = this.editorService.getProgram();
        program.details = this.model;
        this.editorService.updateProgram(program);
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/program-editors/details/program-details-editor.component.ts